import type { SVGProps } from 'react'
const SvgSyTechSolidCloudInterconnect = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g fillRule="evenodd">
			<path d="M2 13h4v-2H2z" />
			<path fillOpacity={0.24} d="M15 17H5V7h10z" />
			<path d="M17.33 13H22v-2h-4.67z" />
			<path d="M8 3v2h9v14H8v2h11V3z" />
			<path d="M15 17h-5V7h5z" />
		</g>
	</svg>
)
export default SvgSyTechSolidCloudInterconnect
